import { colors } from '../constants';
const styleOverrides = {
  root: {
    justifyContent: 'center',
    minHeight: 'unset',
    position: 'relative',
    '&:after': {
      position: 'absolute',
      bottom: 0,
      content: '""',
      width: '100%',
      height: 3,
      backgroundColor: colors.oriGrey[100]
    }
  },
  indicator: {
    height: 3,
    zIndex: 1,
    backgroundColor: colors.text.primary
  },
  scroller: {
    flexGrow: 0,
    zIndex: 1
  }
};
const defaultProps = {
  textColor: 'primary'
};
export default {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiTabs.js.map